import ResponsiveButton from './ResponsiveButton';

export default ResponsiveButton;
